/**
 * [INPUT]: 依赖 react-router 的 MetaFunction/LinksFunction；依赖 ../../src 的 ScoringFlow + SEO 真源
 * [OUTPUT]: 首页路由 / —— 渲染 ScoringFlow（idle 态即 LandingPage 预渲染快照）；meta/links 注入首页 head + JSON-LD
 * [POS]: apps/web/app/routes 的首页；预渲染目标，爬虫拿到真 H1 + 路由级 meta + 5 条 JSON-LD
 * [PROTOCOL]: 变更时更新本头部，然后检查 ../CLAUDE.md
 */
import type { LinksFunction, MetaFunction } from 'react-router'
import { ScoringFlow } from '../../src/components/ScoringFlow'
import { FAQ_ITEMS, ROUTE_SEO, buildHomeJsonLd, buildLinks, buildMeta } from '../../src/seo'

export const meta: MetaFunction = () => [
  ...buildMeta(ROUTE_SEO.home),
  ...buildHomeJsonLd(FAQ_ITEMS).map((json) => ({ 'script:ld+json': json })),
]

export const links: LinksFunction = () => buildLinks(ROUTE_SEO.home)

export default function IndexRoute() {
  return <ScoringFlow />
}